<template>
  <div class="text-center p-2">
    <div>
      <croppa
        v-if="!uploaded"
        class="croppa"
        :class="{ small: size >= 1000 }"
        :width="size"
        :height="size"
        :prevent-white-space="true"
        v-model="myCroppa">
      </croppa>
    </div>
    <button v-if="!uploaded" :disabled="uploading || !hasFile" type="button" class="btn btn-gradient btn-block mt-1" @click="uploadImage()">
      <span v-if="!uploading">{{ $t('save') }}</span>
      <span v-if="uploading"><i class="fa fa-spinner fa-spin"></i></span>
    </button>
    <div v-if="uploaded" class="mt-2">
      File was uploaded successfully, you can now close this window.
    </div>
  </div>
</template>

<script>
import Upload from '../services/upload'

export default {
  name: 'PubicImageUpload',
  data: function () {
    return {
      uploaded: false,
      uploading: false,
      myCroppa: null,
      size: 800
    }
  },
  computed: {
    hasFile: function () {
      return this.myCroppa && this.myCroppa.getChosenFile && this.myCroppa.getChosenFile()
    }
  },
  methods: {
    uploadImage: function (_callback) {
      let path = ''

      if (this.$route.query.target === 'artist') {
        path = 'artist-images'
      } else if (this.$route.query.target === 'user') {
        path = 'profile-images'
      } else if (this.$route.query.target === 'distribution') {
        path = 'distro-covers'
      } else {
        return
      }

      this.uploading = true

      this.myCroppa.generateBlob(
        blob => {
          Upload.uploadImage(blob, path, null, this.$route.query.target, this.$route.query.id).then(response => {
            this.uploaded = true
            this.$forceUpdate()

            if (_callback) {
              _callback()
            }
          }).catch(() => {
            alert('Failed to upload, please contact support')
          })
        },
        'image/jpeg',
        0.8
      ) // 80% compressed jpeg file
    }
  },
  created: function () {
    if (this.$route.query.size) {
      this.size = parseInt(this.$route.query.size)
    }

    if (this.size > 2000) {
      this.size = 1000
    }
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
.croppa {
  zoom: 0.3;
}

.croppa.small {
  zoom: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/PublicImageUpload.vue